<template>
  <div class="title-searches legacy-query-bar" role="region" aria-label="Búsqueda activa">
    <div class="legacy-query-summary">
      <span class="legacy-query-label">Búsqueda:</span>
      <span class="search-text" :title="title">{{ title }}</span>
    </div>
    <button v-if="canSave && stockCount > 0" type="button" class="save-fav-btn"
      :title="'Crear carpeta de favoritos con ' + stockCount + ' tickers'" @click="$emit('save')">
      <span class="material-icons-outlined" aria-hidden="true">grade</span>
      <span class="save-fav-text">Crear carpeta de favoritos</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'LegacyQueryBar',
  props: {
    title: { type: String, default: '' },
    stockCount: { type: Number, default: 0 },
    canSave: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
.legacy-query-bar.title-searches {
  box-sizing: border-box; display: flex; align-items: center; justify-content: center;
  gap: 16px; height: 40px; padding: 0 12px; margin: 0;
  border-bottom: 1px solid var(--workspace-border, #dce3ea);
  background: var(--workspace-heading, #eaf0f5); color: var(--workspace-text, #243648);
  text-align: left;
}
.legacy-query-summary { display: flex; align-items: baseline; gap: 6px; flex: 0 1 auto; min-width: 0; font-size: 13px; line-height: 20px; }
.legacy-query-label { color: var(--workspace-muted, #596b7d); flex-shrink: 0; }
.legacy-query-bar .search-text { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin: 0; line-height: 20px; font-weight: 600; color: inherit; }
.legacy-query-bar .save-fav-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 6px; flex-shrink: 0;
  height: 28px; margin: 0; padding: 0 10px; box-sizing: border-box;
  border: 1px solid var(--workspace-control-border, #b9c7d4); border-radius: 0;
  background: var(--workspace-control, #fff); color: var(--workspace-selected-text, #294a65);
  font: inherit; font-size: 12px; font-weight: 500; line-height: 1; cursor: pointer;
}
.legacy-query-bar .save-fav-btn:hover { background: var(--workspace-hover, #eaf0f5); border-color: var(--workspace-selected-edge, #6f91ae); }
.legacy-query-bar .save-fav-btn:focus-visible { outline: 2px solid var(--workspace-selected-edge, #6f91ae); outline-offset: 2px; }
.legacy-query-bar .save-fav-btn .material-icons-outlined { font-size: 16px; }
.save-fav-text { white-space: nowrap; }
</style>
